import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import CardLayout from "@/layouts/CardLayout.vue";
import Background from "@/components/Background.vue";
import CategoryIcon from "@/components/CategoryIcon.vue";
import Next from "@/components/Next.vue";
import Thumbnail from "@/components/Thumbnail.vue";
import MiniCart from "@/components/MiniCart.vue";
import CommonHeader from "@/components/CommonHeader.vue";
import { localizedProductPrice } from "@/mixins/MenuLocalization";
let Menu = class Menu extends Vue {
    constructor() {
        super(...arguments);
        this.categories = [];
        this.products = [];
        this.showChefRecommended = true;
    }
    seeCategoryOrSubcategory(category) {
        if (category.subcategories.length > 0) {
            this.$store.dispatch('setCategoryId', category.id);
            this.$router.push("/subcategories");
        }
        else {
            this.$router.push("/categories/" + category.id);
        }
    }
    seeProduct(productId) {
        this.$router.push("/products/" + productId);
    }
    getRecommendedProducts() {
        if (this.$store.getters.showRecommended) {
            const products = this.$store.getters.products;
            return products
                .filter(p => p.chefRecommended && localizedProductPrice(p))
                .sort((c, n) => c.chefRecommendedPriority - n.chefRecommendedPriority);
        }
        return [];
    }
    getCategoryWithId(categoryId) {
        return this.categories.find(category => category.id == categoryId);
    }
    getCategories() {
        const categories = this.$store.getters.categories;
        return categories.sort((c, n) => c.order - n.order);
    }
    created() {
        this.categories = this.getCategories();
        this.products = this.getRecommendedProducts();
    }
};
Menu = __decorate([
    Component({
        components: {
            Background,
            CardLayout,
            CommonHeader,
            CategoryIcon,
            Next,
            Thumbnail,
            MiniCart
        }
    })
], Menu);
export default Menu;
